(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmAccount', CrmAccount);

    CrmAccount.$inject = ['$resource','DateUtils'];

    function CrmAccount ($resource, DateUtils) {
        var resourceUrl =  'api/crm-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/crm-accounts/filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        _.forEach(data, function (item) {
                            item.dob = DateUtils.convertDateTimeFromServer(item.dob);
                        })

                    }
                    return data;
                }
            },
        });
    }
})();

